import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import Input from "components/ui/Input";

const TEMPLATES = [
  { key: "registrationReceived", label: "Solicitud de Registro Recibida", icon: "UserPlus" },
  { key: "accountActivated", label: "Cuenta Activada", icon: "CheckCircle" },
  { key: "updateAssigned", label: "Actualización Asignada", icon: "Package" },
  { key: "accountSuspended", label: "Cuenta Suspendida", icon: "UserX" },
];

const TEMPLATE_CONTENT = {
  registrationReceived: {
    subject: "Solicitud de registro recibida - SoftDist",
    body: `Estimado/a {{nombre}},\n\nHemos recibido su solicitud de registro para la organización {{organizacion}} con NIT {{nit}}.\n\nSu solicitud está siendo revisada por nuestro equipo administrativo. Le notificaremos cuando su cuenta sea activada.\n\nGracias por su interés en SoftDist.\n\nAtentamente,\nEquipo SoftDist`,
  },
  accountActivated: {
    subject: "¡Su cuenta ha sido activada! - SoftDist",
    body: `Estimado/a {{nombre}},\n\nNos complace informarle que su cuenta en SoftDist ha sido activada exitosamente.\n\nYa puede acceder al sistema con sus credenciales registradas.\n\nBienvenido/a a SoftDist.\n\nAtentamente,\nEquipo SoftDist`,
  },
  updateAssigned: {
    subject: "Nueva actualización disponible - SoftDist",
    body: `Estimado/a {{nombre}},\n\nSe le ha asignado una nueva actualización: {{nombre_actualizacion}}.\n\nPuede descargarla desde su panel de usuario. El enlace de descarga estará disponible por {{horas_expiracion}} horas.\n\nAtentamente,\nEquipo SoftDist`,
  },
  accountSuspended: {
    subject: "Cuenta suspendida - SoftDist",
    body: `Estimado/a {{nombre}},\n\nSu cuenta en SoftDist ha sido suspendida temporalmente.\n\nPara más información, comuníquese con el administrador del sistema.\n\nAtentamente,\nEquipo SoftDist`,
  },
};

const EmailNotificationsConfig = ({ config, onChange }) => {
  const [activeTemplate, setActiveTemplate] = useState("registrationReceived");
  const [testEmail, setTestEmail] = useState("");
  const [testSent, setTestSent] = useState(false);
  const [templates, setTemplates] = useState(TEMPLATE_CONTENT);

  const handleSmtpChange = (field, value) => {
    onChange("email", field, value);
  };

  const handleTemplateChange = (field, value) => {
    setTemplates((prev) => ({
      ...prev,
      [activeTemplate]: { ...prev?.[activeTemplate], [field]: value },
    }));
  };

  const handleTestSend = () => {
    if (!testEmail) return;
    setTestSent(true);
    setTimeout(() => setTestSent(false), 3000);
  };

  return (
    <div className="space-y-6">
      {/* SMTP Configuration */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(15,118,110,0.1)" }}>
            <Icon name="Mail" size={18} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Configuración SMTP</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Servidor de correo saliente</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input label="Servidor SMTP" type="text" value={config?.smtpHost} onChange={(e) => handleSmtpChange("smtpHost", e?.target?.value)} placeholder="smtp.empresa.com" />
          <Input label="Puerto SMTP" type="number" value={config?.smtpPort} onChange={(e) => handleSmtpChange("smtpPort", e?.target?.value)} placeholder="587" />
          <Input label="Usuario SMTP" type="email" value={config?.smtpUser} onChange={(e) => handleSmtpChange("smtpUser", e?.target?.value)} placeholder="notificaciones@empresa.com" />
          <Input label="Contraseña SMTP" type="password" value={config?.smtpPassword} onChange={(e) => handleSmtpChange("smtpPassword", e?.target?.value)} placeholder="••••••••" />
          <Input label="Correo remitente" type="email" value={config?.fromEmail} onChange={(e) => handleSmtpChange("fromEmail", e?.target?.value)} placeholder="noreply@softdist.co" />
          <Input label="Nombre remitente" type="text" value={config?.fromName} onChange={(e) => handleSmtpChange("fromName", e?.target?.value)} placeholder="SoftDist Notificaciones" />
        </div>
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <Input
            label=""
            type="email"
            value={testEmail}
            onChange={(e) => setTestEmail(e?.target?.value)}
            placeholder="correo@prueba.com"
            className="flex-1"
          />
          <div className="flex items-end">
            <Button variant={testSent ? "success" : "outline"} iconName={testSent ? "CheckCircle" : "Send"} iconPosition="left" onClick={handleTestSend}>
              {testSent ? "¡Enviado!" : "Probar SMTP"}
            </Button>
          </div>
        </div>
      </div>
      {/* Email Templates */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(8,145,178,0.1)" }}>
            <Icon name="FileText" size={18} color="var(--color-secondary)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Plantillas de Correo</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Personalización de mensajes en español colombiano</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-4">
          {TEMPLATES?.map((t) => (
            <button
              key={t?.key}
              onClick={() => setActiveTemplate(t?.key)}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-caption font-500 transition-base"
              style={{
                backgroundColor: activeTemplate === t?.key ? "var(--color-primary)" : "var(--color-muted)",
                color: activeTemplate === t?.key ? "var(--color-primary-foreground)" : "var(--color-foreground)",
              }}
            >
              <Icon name={t?.icon} size={13} color="currentColor" />
              <span className="hidden sm:inline">{t?.label}</span>
              <span className="sm:hidden">{t?.label?.split(" ")?.[0]}</span>
            </button>
          ))}
        </div>
        <div className="space-y-3">
          <Input
            label="Asunto del correo"
            type="text"
            value={templates?.[activeTemplate]?.subject}
            onChange={(e) => handleTemplateChange("subject", e?.target?.value)}
          />
          <div>
            <label className="block text-sm font-caption mb-1" style={{ color: "var(--color-foreground)" }}>Cuerpo del mensaje</label>
            <textarea
              className="w-full rounded-lg border p-3 text-sm font-body resize-none focus:outline-none"
              style={{
                backgroundColor: "var(--color-muted)",
                borderColor: "var(--color-border)",
                color: "var(--color-foreground)",
                minHeight: "160px",
              }}
              value={templates?.[activeTemplate]?.body}
              onChange={(e) => handleTemplateChange("body", e?.target?.value)}
            />
            <p className="text-xs font-caption mt-1" style={{ color: "var(--color-muted-foreground)" }}>
              Variables disponibles: {"{{nombre}}"}, {"{{organizacion}}"}, {"{{nit}}"}, {"{{nombre_actualizacion}}"}, {"{{horas_expiracion}}"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailNotificationsConfig;